module.exports = __webpack_public_path__ + "img/app-store.e1f18429.svg";